import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';
import { SEARCH_SIGN_PROCESS_LONG_OP_SLUG, SIGNER_LONG_OP_SLUG, SIGN_PROCESS_LONG_OP_SLUG, SIGN_PROCESS_SLUG } from './shared/vars';
const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [

  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        SIGN_PROCESS_LONG_OP_SLUG,
        () => import('./sign-process-long-op/sign-process-long-op.module').then(m => m.SignProcessLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        SIGN_PROCESS_SLUG,
        () => import('./sign-process/sign-process.module').then(m => m.SignProcessModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        SEARCH_SIGN_PROCESS_LONG_OP_SLUG,
        () => import('./search-sign-process-long-op/search-sign-process-long-op.module').then(m => m.SearchSignProcessLongOpModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione

  // #region rotte senza autenticazione
  {
    path: '',
    loadComponent: () => import('@nts/std').then(mod => mod.EmptyContainerComponent),
    children: [
      ...BaseRoutes.getEntityRoutes(
        title,
        SIGNER_LONG_OP_SLUG,
        () => import('./signer-long-op/signer-long-op.module').then(m => m.SignerLongOpModule)
      ),
    ],
  },
  // #endregion rotte senza autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    // TODO Tommy: si potrebbe creare una custom preloadin strategy per precaricare solo le rotte offline
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', paramsInheritanceStrategy: 'always', preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
